
<!--
/**
  * 导入文件弹窗
  * @author weili
  * @date 2023-3-3
  */
-->
<template>
  <EXDialog title="导入数据" width="45%" :showVisible="curShowVisible" @close="close">
    <div>
          <el-row :gutter="24">
            <el-col :span="24"> 
              <p>1、下载导入模板，根据模板提示完善内容</p>
            </el-col>
          </el-row>
           <el-row :gutter="24" v-for="(file,index) in downloadFile" :key="index">
            <el-col :span="8" class="filename">{{ file.name }}</el-col>
            <el-col :span="4"> 
              <el-button
                    :plain="true"
                    :type="'primary'"
                    :icon="'fa fa-download'"
                    :size="'medium'"
                    @click="download(file.name,file.url)"
                    >下载</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24"> 
              <p> 2、上传一条完善好的内容，数据请勿放到合并的单元格中。</p>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
               <!-- 附件上传 -->
               <EXUploadFile2
                        ref="file"
                        @update-attachment="updateAttachment"
                        @remove-attachment="removeAttachment"
                        style="width: 100%;padding-left: 0.6rem;"
                        :updateData="updateData"
                        :action="fileUrl"
                        :uploadParams="curUploadParams"
                        :drag="true"
                        :limit="limit" 
                        :itemValue="filename" 
                    ></EXUploadFile2> 
            </el-col>
          </el-row>
        <el-row :gutter="24"></el-row>
        <el-row :gutter="24"></el-row>
        <el-row :gutter="24"></el-row>
        <el-row :gutter="24">
        <el-col :span="24" style="text-align:center">  <!--设置按钮对齐方式-->
                <el-button v-reClick
                    v-for="(item, index) in operationHandle"
                    :key="index"
                    :plain="item.plain || false"
                    :type="item.type || 'primary'"
                    :icon="item.icon || ''"
                    :size="item.size || 'medium'"
                    style="margin-right:10px"
                    @click="item.handle()"
                    >{{ item.label }}</el-button>
          </el-col>
        </el-row>
    </div>
  </EXDialog>
</template>
<script>
// import { baseUrl } from '@/config/env.js'
export default {
  name: 'EXImportDialog',
  components: {
  },
  props:{
    showVisible: Boolean,
    fileUrl: String, //导入方法的后端路径
    downloadFile: {  //导入模板文件列表
       type: Array,
       default: [{
          name: '模板一.xlsx',
          url: '/src/assets/file/模板一.xlsx'
      }] 
    },
    completedEvent: Function,
    updateData:{
       type: Object,
       default: () => ({
          updateMsg: '支持格式：xls、xlsx，单个文件不能超过100MB，最多1个文件',
          updateTypeMsg: '支持格式：xls、xlsx',
          updateSizeMsg: '单个文件不能超过100M',
          updateSize: 104857600,  //文件大小限制（字节byte）
          fileType: '.xls,.xlsx,.XLS,.XLSXF'
       })
    }
  },
  data() {
    return {
      uploadParams:{},
      // fileUrl: `${baseUrl}/api/v1/originalData/importOriginalFile`,
      filename:"file",  
      limit:1,  //文件上传个数
      //表单内容
      formData: {
      },
      operationHandle: [
        {
          label: "导入",
          type: "primary",
          size: "medium",
          handle: this.sureFn
        },
        {
          label: "取消",
          size: "medium",
          plain: true,
          handle: this.close
        },
      ],
      removeFiles: [],  //待删除文件
      // downloadFile :[{
      //     name: '模板一.xlsx',
      //     url: '/src/assets/template/模板一.xlsx'
      // }] //模板文件列表
    };
  },
  created (){
  },
  mounted () {
  },
  computed:{
    curShowVisible(){
        return this.showVisible
    },
    curUploadParams(){
        // if(this.formData.dataTableType){
        //   this.uploadParams = {
        //     dataTableType: this.formData.dataTableType
        //   }
        // }
        return this.uploadParams
    },
  },
  methods:{
    sureFn(){
      this.$confirm('您确认导入吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.doImport()
        }).catch(error=>error);
    },
    async doImport() {
      this.$refs.file.$refs.upload.submit()
    },
    download(name,url){
        var a = document.createElement("a"); 
        a.href = url; // 绝对路径
        a.download = name; //设置文件名
        a.style.display = "none";
        document.body.appendChild(a); 
        a.click(); // 触发a标签的href的读取，浏览器自动下载
        a.remove(); 
    },
    //文件上传成功回调方法
    updateAttachment(attachment,itemValue,res) {
      this.formData[itemValue] = attachment
      this.$emit('completedEvent',res) //回调父组件
      this.close()
    },
    removeAttachment(attachment,file,itemValue) {
        this.formData[itemValue] = attachment
    },
    close(){
        this.$emit('update:showVisible', false) //关闭弹窗
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-left: 0.2rem;
  color: #606266;
}
.filename{
  margin-left: 0.6rem;
  color: #333;
}
/deep/ .el-row{
  line-height: 0.46rem;
}
/deep/ .drag-upload{
  width:6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/EXDialog/EXImportDialog.vue